import { Carousel } from "react-bootstrap";
import { usePvSection4 } from "./landing-pv-section4.hook";
import { DynamicCardProps } from "src/types";
import { DynamicCard } from "src/ui/widgets";

export const PvSection4 = () => {
  const { groupedItems, t } = usePvSection4();

  return (
    <div>
      <div className="pv-section4-title mb-5">
        {t("landing_pv.section4.title")}
      </div>
      <Carousel
        interval={4000}
        controls={false}
        indicators={true}
        className="slow-transition"
      >
        {groupedItems.map((item: DynamicCardProps[], index: number) => (
          <Carousel.Item key={index}>
            <div className="d-md-flex">
              {item.map((item: DynamicCardProps, index: number) => {
                const isThird = (index + 1) % 3 === 0;

                return (
                  <div
                    key={item.carouselCode}
                    className={`card-wrapper ${isThird && "m-0"}`}
                  >
                    <DynamicCard {...item} />
                  </div>
                );
              })}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};
